import styled from 'styled-components';

export const StyledActivityLinkItem = styled.div`
  a {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .activity-image {
      position: relative;
      height: ${(props) => props.imageSize}px;
      width: ${(props) => props.imageSize}px;
      img {
        border-radius: ${(props) => props.imageSize}px;
      }
      .tag {
        font-weight: bold;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .activity-link-item-icon {
      margin-top: -20px;
      text-align: center;
      border-radius: 50%;
      border: 3px solid white;
      z-index: 2;
    }
    .activity-name {
      margin-top: 20px;
      font-weight: bold;
      text-align: center;
    }
    .activity-english-name {
      margin-top: 10px;
      text-align: center;
    }
  }
`;
